// recoil/atoms.js
import { atom } from "recoil";
import { startAuthListener, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { firestoreEffect } from "./firestoreEffect";

// ---------- A. Persistence / Model Concern ----------
// These Atoms represent the persistence of user data.

// Tracks the authenticated user (Firebase Authentication data --> Persistence Concern).
export const loginState = atom({
  key: "loginState",
  default: undefined,
  effects: [
    ({ setSelf }) => {
      // Subscribe to Firebase auth
      startAuthListener((user) => {
        if (!user) {
          setSelf(null);
        } else {
          setSelf({
            uid: user.uid,
            email: user.email,
            name: user.displayName
          });
        }
      });
    }
  ]
});

// Places marked as favorite by the user (stored in Firebase Firestore --> Persistence Concern).
export const savedPlacesState = atom({
  key: "savedPlacesState",
  default: [],
  effects: [
    firestoreEffect({ collection: "userFavorites", field: "favorites" })
  ]
});

// Cultural facts saved by the user (stored in Firebase Firestore --> Persistence Concern).
export const savedFactsState = atom({
  key: "savedFactsState",
  default: [], // Array of fact objects
});

// ---------- B. Presenters Concern ---------- 
// These Atoms reflect the user Input that triggers the logic (Presenters).

// The text input from the 'Search' field. Used to initiate the places search logic.
export const searchQueryState = atom({
  key: "searchQueryState",
  default: "",
});

// Selected categories
export const selectedCategoriesState = atom({
  key: "selectedCategoriesState",
  default: [],
  effects: [
    firestoreEffect({ collection: "userCategories", field: "categories" })
  ]
});

// The selected category (e.g., 'history', 'pubs') from the dropdown.
export const searchTypeState = atom({
  key: "searchTypeState",
  default: "",
});

// If the user has navigation menu open on mobile.
export const isNavigationMenuOpenState = atom({
  key: "navigationMenuOpenState",
  default: false,
});

// The selected city in favorites. 
export const selectedCityState = atom({
  key: "selectedCityState",
  default: "all",
});

// ---------- C. Views Concern ---------- 
// These Atoms reflect the result of an operation (API, Presenter) and are consumed directly by the View to render the information.

// Stores the raw list of places returned by the Places API.
export const searchResultsState = atom({
  key: "searchResultsState",
  default: [],
  effects: [
    firestoreEffect({ collection: "userSearchResults", field: "results" })
  ]
});

// Status flag for asynchronous operations (crucial for good UX/Visibility of Status).
export const isLoadingState = atom({
  key: "isLoadingState",
  default: null,
});

// Stores the cultural fact just generated by the Gemini LLM API.
// It remains here until the user saves it or requests a new one.
export const currentFactState = atom({
  key: "currentFactState",
  default: null, // The current fact object or null
});

export const selectedPlaceState = atom({
  key: "selectedPlaceState",
  default: null
});

export const routePlacesState = atom({
  key: "routePlacesState",
  default: [], // array of originalPlace objects
});